// 列表转树
const toTree = (data, pid) => {
    let tree = [];
    let temp;
    for (let i = 0; i < data.length; i++) {
        if (data[i].pid == pid) {
            let obj = data[i];
            temp = toTree(data, data[i].id);
            if (temp.length > 0) {
                obj.children = temp;
            }
            tree.push(obj);
        }
    }
    return tree;
}

// 列表转树
const addrFilter = (data, level = 2) => {
    let tree = []
    data.forEach(item => {
        if(item.level <= level){
            tree.push(item)
        }
    })
    return toTree(tree, 0)
}

// 根据字段分组
const mapLoction = (arr, label) => {
    let newArr = [];
    arr.forEach(function (oldData, i) {
        let index = -1;
        let alreadyExists = newArr.some(function (newData, j) {
            if (oldData[label] === newData[label]) {
                index = j;
                return true;
            }
        });
        if (!alreadyExists) {
            newArr.push({
                [label]: oldData[label],
                children: [oldData]
            });
        } else {
            newArr[index].children.push(oldData);
        }
    });
    return newArr;
}

// 时间格式过滤
const dateTime = (date, format = 'yyyy-MM-dd hh:mm:ss') => {
    date = new Date(date)
    if(!isNaN(date)&&!isNaN(Date.parse(date))){
    　　let o = {   
            "M+" : date.getMonth() + 1,
            "d+" : date.getDate(),
            "h+" : date.getHours(),
            "m+" : date.getMinutes(),
            "s+" : date.getSeconds(),
            "q+" : Math.floor((date.getMonth() + 3) / 3),
            "S"  : date.getMilliseconds()
        };   
        if(/(y+)/.test(format)){
            format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));   
        }
        for(let k in o){
            if(new RegExp("("+ k +")").test(format)){
                format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            }
        }  
        return format;
    }else{
        return '--'
    }
    
}
 let _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
//转码
var fincode = function (val) {
        // console.log()
        val = val.replace(/\r\n/g,"\n");
        var utftext = "";
        for (var n = 0; n < val.length; n++) {
            var c = val.charCodeAt(n);
            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }

        }
        return utftext;
    }
//base64加密
const encode=(input) => {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        input = fincode(input);
        while (i < input.length) {
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output = output +_keyStr.substr(enc1, 1) + _keyStr.substr(enc2, 1) + _keyStr.substr(enc3, 1) + _keyStr.substr(enc4, 1);
        }
        return output;
	}
const testfilters = (val) => {
	let testdata=['','ERMT','CAERM','CERM','CSERM']
    if(isNaN(val)){
		return testdata.indexOf(val)
	}else{
		return testdata[val]
	}
}
export { toTree, mapLoction, dateTime,encode,addrFilter,testfilters }